import type { BadgeTone } from '@/components/ui/Badge';
import type { BroadcastDeliveryStatus, MessageChannel } from '@/types/messaging';

/**
 * How a message's delivery reads, and the tone it carries.
 *
 * One table for the office's delivery log and the parent's inbox, so "Pending"
 * cannot mean one thing on the screen that sent a message and another on the
 * screen that received it (CLAUDE.md §3).
 */
export const DELIVERY_STATUS_LABEL: Record<
  BroadcastDeliveryStatus,
  { label: string; tone: Extract<BadgeTone, 'success' | 'critical' | 'neutral'> }
> = {
  DELIVERED: { label: 'Delivered', tone: 'success' },
  FAILED: { label: 'Failed', tone: 'critical' },
  PENDING: { label: 'Pending', tone: 'neutral' },
};

/** What each channel is called on screen. */
export const CHANNEL_LABEL: Record<MessageChannel, string> = {
  SMS: 'SMS',
  WHATSAPP: 'WhatsApp',
};
